<template>
  <ConfirmationSmartBoostModal />
  <SmartBoostVideoModal :isOpen="isVideoOpen" @closeModal="closeVideo" :title="$t('rc_smartboost_video_header')" />
  <div class="tw:flex tw:md:hidden">
    <MobileInformationCard title="rc_smartboost_mobile_header" subtitle="rc_smartboost_mobile_subtext" />
  </div>
  <div class="tw:hidden tw:md:flex tw:flex-col">
    <BaseCard noPadding class="tw:bg-white tw:rounded-lg">
      <SmartBoostBanner
        @openVideo="openVideo"
        v-show="activeBoosts !== undefined && Object.keys(activeBoosts).length === 0"
      />
      <div class="tw:pt-6">
        <SmartBoostHeader v-show="Object.keys(activeBoosts || {})?.length > 0" @openVideo="openVideo" />
        <SmartBoostTabs
          :tabs="tabsConfig"
          defaultTab="activeBoosts"
          :activeTab="activeTab"
          @changeActiveTab="changeActiveTab"
        >
          <template #activeBoosts>
            <div class="tw:px-4 tw:pb-4">
              <SmartBoost />
            </div>
          </template>

          <template #history>
            <SmartBoostHistory />
          </template>
        </SmartBoostTabs>
      </div>
    </BaseCard>
  </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue'

import BaseCard from '@/components/dashboard/BaseCard.vue'
import SmartBoostVideoModal from '@/components/rateConnect/smartBoost/SmartBoostVideoModal.vue'
import SmartBoostBanner from '@/components/rateConnect/smartBoost/SmartBoostBanner.vue'
import SmartBoostTabs from '@/components/rateConnect/smartBoost/SmartBoostTabs.vue'
import SmartBoost from '@/components/rateConnect/smartBoost/SmartBoost.vue'
import ConfirmationSmartBoostModal from '@/components/rateConnect/smartBoost/ConfirmationSmartBoostModal.vue'
import SmartBoostHeader from '@/components/rateConnect/smartBoost/SmartBoostHeader.vue'
import MobileInformationCard from '@/components/rateConnect/performance/MobileInformationCard.vue'
import SmartBoostHistory from '@/components/rateConnect/smartBoost/SmartBoostHistory.vue'

import { useActiveBoosts, useBoostsHistory } from '../queries'
import { selectedAccommodationId } from '@/layouts/queries'
import { useSmartBoost } from './useSmartBoost'

const isVideoOpen = ref(false)
const openVideo = () => (isVideoOpen.value = true)
const closeVideo = () => (isVideoOpen.value = false)

const props = defineProps({
  selectedTab: String,
})
const { loadExistingActiveBoostsForEditing, setEditingMode, clearDates, clearActiveBoostDates } = useSmartBoost()
const { activeBoosts } = useActiveBoosts(selectedAccommodationId)
const { boostsHistory } = useBoostsHistory(selectedAccommodationId)
const tabsConfig = computed(() => [
  {
    id: 'activeBoosts',
    label: 'rc_smartboost_active_tab',
    isDisabled: false,
    linkName: 'rate-connect-running-smart-boost',
  },
  {
    id: 'history',
    label: 'rc_smartboost_activity_header',
    isDisabled: !boostsHistory.value || boostsHistory.value.length === 0,
    linkName: 'rate-connect-running-smart-boost-history',
  },
])

const activeTab = ref(props.selectedTab)
const changeActiveTab = id => (activeTab.value = id)

watch(
  activeBoosts,
  newValue => {
    const timestampsSet = new Set()

    if (newValue && Object.keys(newValue).length > 0) {
      setEditingMode(true)

      Object.values(newValue).forEach(boosts => {
        boosts.forEach(boost => {
          const startDate = new Date(boost.startDate + 'T00:00:00')
          const endDate = new Date(boost.endDate + 'T00:00:00')

          const currentDate = new Date(startDate)
          while (currentDate <= endDate) {
            timestampsSet.add(currentDate.getTime())
            currentDate.setDate(currentDate.getDate() + 1)
          }
        })
      })

      loadExistingActiveBoostsForEditing(Array.from(timestampsSet))
    } else {
      // No active boosts - creation mode
      clearDates()
      clearActiveBoostDates()
      setEditingMode(false)
    }
  },
  { immediate: true, deep: true }
)
</script>
